import { useTranslation } from 'react-i18next'

interface ObjectImageViewTabProps {
    image?: string | null
}

export function ObjectImageViewTab({ image }: ObjectImageViewTabProps) {
    const { t } = useTranslation()

    return (
        <div className="space-y-4">
            <div className="space-y-2">
                <h3 className="text-sm font-medium">{t('objects.objectImage')}</h3>
                <div className="border-2 border-dashed border-muted-foreground/25 rounded-lg p-8 text-center">
                    <p className="text-muted-foreground">
                        {t('objects.objectImagePlaceholder')}
                    </p>
                    <p className="text-sm text-muted-foreground mt-2">
                        {t('objects.objectImageDescription')}
                    </p>
                </div>
            </div>
        </div>
    )
}
